<template>
    <v-dialog width="650" v-model="isOpenSummaryBadgeTable" persistent>
        <v-card class="mx-auto">
            <v-card-title class="d-flex justify-center">
                <h3 class="font-weight-light primary--text">
                    Bolsas Establecidas
                </h3>
            </v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12" md="6" class="d-flex justify-center">
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    dark
                                    outlined
                                    color="primary"
                                    v-on="on"
                                    >{{ 'Mes: ' + date.toString() }}
                                    <v-icon rigth>mdi-calendar</v-icon>
                                </v-btn>
                            </template>
                            <v-date-picker
                                color="primary"
                                v-model="date"
                                type="month"
                                no-title
                                scrollable
                            >
                                <v-spacer></v-spacer>
                                <v-btn text color="red" @click="menu = false">
                                    Cerrar
                                </v-btn>
                                <v-btn
                                    depressed
                                    text
                                    color="primary"
                                    @click="
                                        searchNewDate(date);
                                        $refs.menu.save(date);
                                    "
                                >
                                    Guardar
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="6" class="d-flex justify-center">
                        <v-btn
                            depressed
                            @click="openAddBadgeDialog()"
                            color="green darken-2"
                            outlined
                            dark
                            small
                        >
                            Crear Bonificación
                            <v-icon right>mdi-bag-personal-outline</v-icon>
                            <AddBadgeDialog />
                        </v-btn>
                    </v-col>
                </v-row>
                <v-data-table
                    :loading="isLoadingBadges"
                    :headers="headers"
                    :items="badges"
                    class="elevation-0"
                    :search="search"
                    disable-sort
                    :footer-props="footer_props"
                >
                    <template v-slot:top>
                        <v-text-field
                            v-model="search"
                            label="Buscar"
                            class="mx-4"
                        ></v-text-field>
                    </template>
                    <template v-slot:item.created_on="{ item }">
                        {{ formatDate(item.created_on) }}
                    </template>
                    <template v-slot:item.reward_type="{ item }">
                        <div class="text-capitalize">
                            {{
                                item.reward_type
                                    ? item.reward_type
                                          .toLowerCase()
                                          .replace('_', ' ')
                                    : ''
                            }}
                        </div>
                    </template>
                    <template v-slot:item.Actions="{ item }">
                        <v-col v-if="hasAdminPermission" md="12">
                            <div class="d-flex flex-row justify-space-between">
                                <v-btn
                                    fab
                                    @click="openDeleteDialog(item)"
                                    x-small
                                    color="red"
                                    outlined
                                >
                                    <v-icon> mdi-delete </v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                    </template>
                </v-data-table>
            </v-card-text>

            <v-card-actions elevation="0" class="justify-end mt-n8">
                <v-btn
                    text
                    color="red"
                    @click="isOpenSummaryBadgeTable = false"
                >
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
        <DeleteDialog />
    </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { clone, dateToISOString } from '@/util/libUtil.js';

import AddBadgeDialog from '@/components/AreaPersonal/Calculadora/BolsaFija/addBadgeDialog.vue';
import DeleteDialog from '@/components/DeleteDialog/DeleteDialog.vue';

export default {
    data: () => ({
        search: '',
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        headers: [
            {
                text: 'Nombre',
                value: 'commercial.nombre_completo',
                align: 'start',
            },
            { text: 'Fecha', value: 'created_on', align: 'center' },
            { text: 'Tipo bolsa', value: 'reward_type', align: 'center' },
            { text: 'Cantidad', value: 'amount', align: 'center' },
            {
                text: 'Acciones',
                value: 'Actions',
                align: 'center',
                width: '100px',
            },
        ],
        footer_props: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [10],
        },
    }),
    components: {
        AddBadgeDialog,
        DeleteDialog,
    },
    computed: {
        isOpenSummaryBadgeTable: {
            get() {
                return this.$store.state.areaPersonal.calculadora
                    .isOpenSummaryBadgeTable;
            },
            set(value) {
                this.$store.commit(
                    'areaPersonal/calculadora/isOpenSummaryBadgeTable',
                    value
                );
            },
        },
        tenantInfo() {
            return JSON.parse(localStorage.getItem('tenantInfo'));
        },
        ...mapState('areaPersonal/calculadora', {
            badges: (state) => state.badges,
            dateActualInmutable: (state) => state.dateActualInmutable,
            isLoadingBadges: (state) => state.isLoadingBadges,
            selectedComercial: (state) => state.selectedComercial,
            currentDate: (state) => state.date,
        }),
        ...mapGetters('login', {
            hasSuperAdminPermission: 'hasSuperAdminPermission',
            hasAdminPermission: 'hasAdminPermission',
            hasManagerPermission: 'hasManagerPermission',
            hasComercialPermission: 'hasComercialPermission',
        }),
    },
    methods: {
        formatDate(date) {
            return new Date(date).toISOString().substr(0, 7);
        },
        searchNewDate() {
            let params = {
                created_on: this.date,
            };
            if (new Date(this.date) >= this.dateActualInmutable) {
                params = { ...params, is_active: true };
            }
            this.$store.dispatch('areaPersonal/calculadora/getBadge', params);
        },
        openDeleteDialog(item) {
            let deleteObj = {
                toDeleteId: item.id,
                toDeleteType: 'BADGE',
                isOpenDeleteDialog: true,
            };

            this.$store.commit('util/deleteDialog', clone(deleteObj));
        },
        openAddBadgeDialog() {
            this.$store.commit(
                'areaPersonal/calculadora/isOpenAddBadgeDialog',
                true
            );
        },
        ...mapActions('areaPersonal/calculadora', ['getBadge']),
    },
    watch: {
        isOpenSummaryBadgeTable: {
            immediate: true,
            handler: function (newValue, oldValue) {
                if (
                    this.hasAdminPermission &&
                    newValue &&
                    !this.badges.length
                ) {
                    let params = {
                        created_on: this.date,
                    };
                    if (new Date(this.date) >= this.dateActualInmutable) {
                        params = { ...params, is_active: true };
                    }
                    this.getBadge(params);
                }
            },
        },
        selectedComercial: {
            immediate: true,
            handler: function (newValue) {
                if (newValue != null) {
                    if (this.currentDate) {
                        let params = {
                            commercial: newValue.id,
                            created_on: this.date,
                        };
                        if (
                            dateToISOString(this.currentDate) >=
                            this.dateActualInmutable
                        ) {
                            params = { ...params, is_active: true };
                        }
                        // this.$store.dispatch(
                        //     'areaPersonal/calculadora/fetchRewardType',
                        //     params
                        // );
                    }
                }
            },
        },
    },
};
</script>








